import { Box } from 'grommet';
import React from 'react';

const MainSeparator = () => {
    return (
        <Box style={{height: 6, backgroundColor: '#E92C70', marginTop: 24, marginBottom: 30}}/>
    )
}

export default MainSeparator;